export default "/assets/images/pet-dander-png.272eeefadf2df164.png";